var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SNS Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5541 7.00339V10.2696C20.5541 10.2696 17.7312 10.4234 15.4964 8.5596V16.0421C15.4964 16.3316 15.4693 16.6121 15.415 16.9016C15.1436 18.2316 14.0126 21.5974 9.56113 21.9864C9.33494 22.0045 9.10875 22.0045 8.88255 21.9864C7.61587 21.8779 3.82488 21.1721 3.07391 16.6121C2.98344 16.0873 2.97439 15.5535 3.05582 15.0287C3.28201 13.4725 4.89251 9.19294 10.1854 9.70866V12.9568C10.1854 12.9568 7.91445 12.4139 6.81062 14.1692C6.23157 15.0921 6.16824 16.2502 6.65681 17.2183C7.02777 17.9602 7.77873 18.7202 9.24446 18.7745C9.85971 18.7745 11.814 18.5573 12.2483 16.1416V2H15.4964C15.4964 2 15.4964 6.68672 20.5632 7.00339H20.5541Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.813909a1a16795c9be09da3ffc7bc0f2.svg";
export { ForwardRef as ReactComponent };